<template>
    <div class="renew-item"
        :class="curItem.class">
        <!-- 卡片 -->
        <div class="renew-item__card"
            :style="{ background: `url(${curItem.bg}) center / cover no-repeat` }">
            <img class="top-icon" :src="curItem.topIcon" :alt="curItem.name">
            <img class="juzhen" src="../images/juzhengdian.png" alt="矩阵点">
            <div v-if="curItem.isRecommend"
                class="recommend color-fff fs-12 fw-600 align-c">
                <span class="recommend-text">推荐</span>
            </div>
            <h2 class="fs-30 lh-30 pt-30 name">{{ curItem.name }}</h2>
            <p class="fs-14 lh-20 mt-4">
                <span class="fit-to">{{ curItem.fitTo }}</span>
            </p>
            <p class="fs-12 lh-20 fit-to-text">{{ curItem.fitToText }}</p>
            <!-- 活动信息 -->
            <div v-if="isHaveActivity && maxDiscount > 0">
                <p class="fs-14 mt-6 lh-20">原价{{ +curItem.yearServiceFee.price }}元，最高立省{{ +saveMoney }}元</p>
                <p class="fs-12 lh-17 fit-to-text">活动时间：{{ startTime }} 至 {{ endTime}}</p>
            </div>
            <div class="btn-wrapper">
                <p v-if="false"
                    class="fs-12 lh-17 mb-4">
                    <!-- <span class="line-through mr-10 opa-7">年服务费：¥{{ +curItem.yearServiceFee.price }}/年</span> -->
                    <span class="mr-10 opa-7">年服务费：¥{{ +curItem.yearServiceFee.price }}/年</span>
                    <!-- <span>首年免服务费</span> -->
                </p>
                <div class="btn fs-18 fw-600 renew-btn"
                    @click="toBuy">
                    <span class="fs-12">￥</span>
                    <!-- {{ isShiYong ? +curItem.buyFee.price : +curItem.yearServiceFee.price }}  -->
                    {{ isHaveActivity && maxDiscount > 0 ? +disCountPrice.toFixed(2) : +curItem.yearServiceFee.price }}
                    <!-- 购买 -->
                    <!-- {{ isShiYong ? '立即购买' : '立即续费' }} -->
                    {{ buttonText }}
                    <!-- 折扣信息 -->
                    <span class="dicount-bg" v-if="isHaveActivity && maxDiscount > 0">{{ maxDiscount }}折</span>
                </div>
            </div>
        </div>
        <!-- 详细 -->
        <ul class="renew-item__details fs-12 align-c">
            <li v-for="item in curItem.iconsAndText"
                :key="item.tips">
                <img :src="item.icon" :alt="item.tips">
                <p class="tips lh-16 color-999 mt-6 mb-2">{{ item.tips }}</p>
                <p v-for="txt in item.text"
                    class="txt lh-17 color-333 fw-600"
                    :key="txt">{{ txt }}</p>
            </li>
        </ul>
        <order-confirm
            :isShiYong="isShiYong"
            ref="orderConfirm"
            :count="CanBuyYear"
            :type="type"
            :serveInfo='serveInfo'
            :remark="remark"
            :remainDay="remainDay"
            :isHaveActivity="isHaveActivity"
            :originItemPrice="originItemPrice.yearServiceFee"
            :maxYears="maxYears"
            :primer="curItem.yearServiceFee"  />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, computed, onBeforeMount, onMounted } from '@vue/composition-api'
import { IRenewPayInfo } from '../new_renew.vue'
import OrderConfirm from './order_confirm.vue'
import { editionJudge } from '../../../utils/editionJudge'
import { useStore } from '../../../store'
import { openActivateCodeWithGetShopInfo } from '@/components/activate_code/activate_code.tsx'
import { openMessage } from '../../../utils/system'
import dayjs from 'dayjs'
import $fetch from '@/api'
import clone from 'lodash/cloneDeep'
import { Message } from 'element-ui'

// 0     收银台标准版
// 1     收银台专业版
// 2     收银台旗舰版

// 1002  收银台标准版服务费
// 1003  收银台专业版服务费
// 1004  收银台旗舰版服务费

// 1015  收银台标准版初装费
// 1016  收银台专业版初装费
// 1017  收银台旗舰版初装费

export default createComponent({
    props: {
        type: {
            type: Number,
            default: 0
        },
        renewPayInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    setup: (props: {
        type: number
        renewPayInfo: IRenewPayInfo
    }, ctx) => {
        // 0 续费  1 升级
        const serveInfo = ref(0)

        // 备注信息
        const remark = ref('系统升级，标准版升级为专业版')
        const maxYears = ref(0)

        const getAll = computed(() => {
            return [{
                name: '标准版',
                class: 'is-biaozhun',
                fitTo: '适用于夫妻店等小型商铺',
                fitToText: '满足收银、管理、营销等需求',
                bg: require('../images/biaozhun/biaozhun-card.svg'),
                topIcon: require('../images/biaozhun/biaozhun-dingbu.svg'),
                isRecommend: false,
                id: props.renewPayInfo.biaozhunServiceFee.id,
                years: props.renewPayInfo.biaozhunServiceFee.expired_date_info,
                yearServiceFee: props.renewPayInfo.biaozhunServiceFee,
                buyFee: props.renewPayInfo.biaozhunBuyFee,
                iconsAndText: [{
                    icon: require('../images/biaozhun/biaozhun-dingdan.svg'),
                    tips: '年订单数上限',
                    text: ['5万单']
                }, {
                    icon: require('../images/biaozhun/biaozhun-yuangong.svg'),
                    tips: '员工数',
                    text: ['仅超管']
                }, {
                    icon: require('../images/biaozhun/biaozhun-jilu.svg'),
                    tips: '操作记录',
                    text: ['保留7天']
                }, {
                    icon: require('../images/biaozhun/biaozhun-guanggao.svg'),
                    tips: '副屏广告',
                    text: ['支持图片轮播']
                }, {
                    icon: require('../images/biaozhun/biaozhun-xiaopiao.svg'),
                    tips: '自定义小票',
                    text: ['支持文字']
                }, {
                    icon: require('../images/biaozhun/biaozhun-fenzu.svg'),
                    tips: '商品分组',
                    text: ['5个一级分组']
                }]
            }, {
                name: '专业版',
                class: 'is-zhuanye',
                fitTo: '适用于所有零售单店、初级连锁店',
                fitToText: '营销玩法更丰富，管理功能更强大',
                bg: require('../images/zhuanye/zhuanye-card.svg'),
                topIcon: require('../images/zhuanye/zhuanye-dingbu.svg'),
                isRecommend: true,
                id: props.renewPayInfo.zhuanyeServiceFee.id,
                years: props.renewPayInfo.zhuanyeServiceFee.expired_date_info,
                yearServiceFee: props.renewPayInfo.zhuanyeServiceFee,
                buyFee: props.renewPayInfo.zhuanyeBuyFee,
                iconsAndText: [{
                    icon: require('../images/zhuanye/zhuanye-dingdan.svg'),
                    tips: '年订单数上限',
                    text: ['10万单']
                }, {
                    icon: require('../images/zhuanye/zhuanye-yuangong.svg'),
                    tips: '员工数',
                    text: ['6位']
                }, {
                    icon: require('../images/zhuanye/zhuanye-jilu.svg'),
                    tips: '操作记录',
                    text: ['保留90天']
                }, {
                    icon: require('../images/zhuanye/zhuanye-guanggao.svg'),
                    tips: '副屏广告',
                    text: ['支持图片轮播', '视频轮播(1个)']
                }, {
                    icon: require('../images/zhuanye/zhuanye-xiaopiao.svg'),
                    tips: '自定义小票',
                    text: ['支持文字+图片']
                }, {
                    icon: require('../images/zhuanye/zhuanye-fenzu.svg'),
                    tips: '商品分组',
                    text: ['12个一级分组', '3个二级分组']
                }]
            }, {
                name: '旗舰版',
                class: 'is-qijian',
                fitTo: '适用于所有零售连锁店',
                fitToText: '打通订货、采购、配送、零售全流程',
                bg: require('../images/qijian/qijian-card.svg'),
                topIcon: require('../images/qijian/qijian-dingbu.svg'),
                isRecommend: false,
                id: props.renewPayInfo.qijianServiceFee.id,
                years: props.renewPayInfo.qijianServiceFee.expired_date_info,
                yearServiceFee: props.renewPayInfo.qijianServiceFee,
                buyFee: props.renewPayInfo.qijianBuyFee,
                iconsAndText: [{
                    icon: require('../images/qijian/qijian-dingdan.svg'),
                    tips: '年订单数上限',
                    text: ['30万单']
                }, {
                    icon: require('../images/qijian/qijian-yuangong.svg'),
                    tips: '员工数',
                    text: ['15位']
                }, {
                    icon: require('../images/qijian/qijian-jilu.svg'),
                    tips: '操作记录',
                    text: ['保留一年']
                }, {
                    icon: require('../images/qijian/qijian-guanggao.svg'),
                    tips: '副屏广告',
                    text: ['支持图片轮播', '视频轮播(5个)']
                }, {
                    icon: require('../images/qijian/qijian-xiaopiao.svg'),
                    tips: '自定义小票',
                    text: ['支持文字+图片']
                }, {
                    icon: require('../images/qijian/qijian-fenzu.svg'),
                    tips: '商品分组',
                    text: ['20个一级分组', '5个二级分组']
                }]
            }]
        })

        const curItem = computed(() => getAll.value[props.type])
        // 计算目前使用版本的价格
        const originItemPrice = computed(() =>  getAll.value[editionJudge.getShopVersion])
        console.log(originItemPrice, 'originItemPrice')
        const isShiYong = computed(() => {
            return editionJudge.isShiYong
        })
        // 活动的开始时间
        const startTime = computed(() => {
            return props.renewPayInfo.activityInfo.start_time.split(' ')[0]
        })
        const endTime = computed(() => {
            return props.renewPayInfo.activityInfo.end_time.split(' ')[0]
        })

        // 是否有活动可以用
        const isHaveActivity = computed(() => {
            return props.renewPayInfo.activityInfo.status === 1 ? true : false
        })

        // 是否可以续费
        const isCanRenew = computed(() => {
            // 试用可以续费， 
            return editionJudge.isShiYong || (!editionJudge.isShiYong && editionJudge.getShopVersion <= props.type) || (+remainDay.value < 0)
        })
       
        // 处理折扣信息
        const discountInfo = computed(() => {
            return props.renewPayInfo.activityInfo.detail_info.filter(item => item.fee_id === curItem.value.id)
        })

        // 计算最大折扣信息(也是值最小)
        const maxDiscount = computed(() => {
            const discountInfoArr = clone(discountInfo)
            // console.log(Math.min.call(Math, ...discountInfoArr.value.map( item => item.discount_percent).filter( item => item > 0)))
            const arr2 = discountInfoArr.value.map( item => item.discount_percent).filter( item => item > 0)
            if (arr2.length > 0 ) {
                 return Math.min.call(Math, ...arr2)
            } else {
                return 0
            }
           
        })


        // 处理时间的年份和折扣
        const CanBuyYear = computed(() => {
            const years =  curItem.value.years
            const discountArr = discountInfo.value
            // 计算最大的购买年数
            if (years) {
                maxYears.value = Math.max.call(Math, ...years)
            }
            console.log()
            let arr:any = []
            years.forEach(item => {
                arr.push({
                    expired_date: item,
                    discount_percent: ''
                })
            })
            // 判断是否有折扣信息
            if (isHaveActivity.value) {
                arr.forEach( item => {
                    discountArr.find( (item1) => {
                        if (item1.expired_date === item.expired_date) {
                            item.expired_date = item1.expired_date
                            item.discount_percent = +item1.discount_percent
                        }
                    })
                })
                return arr
            } else {
                return arr
            }
            

            
        })

        // 计算优惠的价格
        const disCountPrice = computed( () => {
            if (maxDiscount) {
                return +maxDiscount.value * 0.1 * +curItem.value.yearServiceFee.price
            }
            console.log(maxDiscount, 'maxDiscount')
            return +curItem.value.yearServiceFee.price
        })

        // 立省
        const saveMoney = computed(() => {
            return  (+curItem.value.yearServiceFee.price -  disCountPrice.value).toFixed(2)
        })

        // 判断是续费 购买 升级
        const buttonText = computed(() => {
            console.log(editionJudge.isShiYong, editionJudge.isShiYong)
            if (editionJudge.isShiYong) {
                return '立即购买'
            } else {
                // 标准版 0 与 当前版本对比 0 0 续费 1 2 升级
                if ( editionJudge.getShopVersion === 0 ) {
                    if (props.type === 0 ) {
                        serveInfo.value = 0
                        return '立即续费'
                    } else if (props.type === 1) {
                         serveInfo.value = 1
                        remark.value = '系统升级，标准版升级为专业版'
                        return '立即升级'
                    } else if (props.type === 2) {
                        serveInfo.value = 1
                        remark.value = '系统升级，标准版升级为旗舰版'
                        return '立即升级'
                    }
                }
                // 专业版1 0 续费  1 续费  2 升级a
                if ( editionJudge.getShopVersion === 1) {
                    // 专业版 1
                    if (props.type  === 0) {
                        serveInfo.value = 0
                        return '立即续费'
                    } else if ( props.type === 1 ) {
                        serveInfo.value = 0
                        return '立即续费'
                    } else  if (  props.type === 2 ) {
                        serveInfo.value = 1
                        remark.value = '系统升级，专业版升级为旗舰版'
                        return '立即升级'
                    }   
                }

                // 旗舰版2 0 都是续费
                if ( editionJudge.getShopVersion === 2) {
                    if (props.type === 0) {
                        remark.value = '系统升级，标准版升级为旗舰版'
                    }

                    if (props.type === 1) {
                        remark.value = '系统升级，专业版升级为旗舰版'
                    }
                    serveInfo.value = 0
                    return '立即续费'
                }

            }
        })

        // 还剩多少天
        const remainDay = computed(() => {
            console.log(editionJudge.remainDay)
            return editionJudge.remainDay
        })

        // 去购买
        function toBuy() {
            if (editionJudge.isSunmi) {
                // return openActivateCodeWithGetShopInfo()
                return openMessage('error', '请联系您的服务商进行购买，如有疑问请拨打400-6666-509')
            }

            
            if (isCanRenew.value) {
                (ctx.refs as any).orderConfirm.open()
            } else {
                return openMessage('error', '当前版本到期后才可续费低级版本')
            }
        }

        return {
            isShiYong,
            curItem,
            toBuy,
            startTime,
            endTime,
            maxDiscount,
            disCountPrice,
            discountInfo,
            saveMoney,
            buttonText,
            serveInfo,
            remark,
            remainDay,
            originItemPrice,
            isHaveActivity,
            CanBuyYear,
            maxYears
        }
    },

    components: {
        OrderConfirm
    }
})
</script>

<style lang="scss" scoped>
@mixin fitTo ($lColor: rgba(255, 255, 255, .1), $rColor: #FFF) {
    position: relative;

    &::before,
    &::after {
        content: '';
        position: absolute;
        width: 48px;
        height: 2px;
        top: 50%;
        margin-top: -1px;
        border-radius: 2px;
    }

    &::before {
        left: -57px;
        background-image: linear-gradient(46deg, $lColor 0%, $rColor 100%);
    }

    &::after {
        right: -57px;
        background-image: linear-gradient(-46deg, $lColor 0%, $rColor 100%);
    }
}

@mixin qijianColor () {
    background: linear-gradient(to left, #FFEADC, #FFC29E);
    background-clip: text;
    color: transparent;
}

.renew-item {
    width: 100%;

    &.is-biaozhun {
        color: #fff;

        .renew-item__card {
            box-shadow: 0 8px 10px -5px rgba(20,204,155,0.71);

            .fit-to {
                @include fitTo();
            }

            .recommend::before {
                border-color: transparent transparent #27CA5D transparent;
            }

            div.btn-wrapper .renew-btn {
                color: #14CC9B;
                background-image: linear-gradient(90deg, #DBFDF4 0%, #EBFFF6 100%);
                box-shadow: 0 6px 10px -5px rgba(20,204,155,0.50);
            }
        }
    }

    &.is-zhuanye {
        color: #fff;

        .renew-item__card {
            box-shadow: 0 8px 10px -5px #EDB262;

            .fit-to {
                @include fitTo();
            }

            .recommend::before {
                border-color: transparent transparent #F0C479 transparent;
            }

            div.btn-wrapper .renew-btn {
                color: #F1C774;
                background-image: linear-gradient(270deg, #FFF7E8 0%, #FFF7E7 100%);
                box-shadow: 0 2px 10px 0 rgba(236,177,97,0.50);
            }
        }
    }

    &.is-qijian {
        color: #FFC29E;
        // box-shadow: 0 8px 10px -5px rgba(red, green, blue, alpha);
       

        .renew-item__card {
            box-shadow: 0 8px 10px -5px rgba(42,40,37,0.50);

            h2,
            .fit-to {
                @include qijianColor();
            }

            .fit-to {
                @include fitTo(rgba(0, 0, 0, .1), #FFC29E);
            }

            .recommend::before {
                border-color: transparent transparent #5A493A transparent;
            }

            div.btn-wrapper .renew-btn {
                color: #65503E;
                background-image: linear-gradient(-46deg, #FFEADC 0%, #FFC29E 100%);
                box-shadow: 0 2px 10px 0 rgba(236,177,97,0.50);
            }
        }
    }

    &__card {
        position: relative;
        height: 200px;
        margin: 22px 26px 10px;
        text-align: center;

        .top-icon {
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translateX(-50%);
            width: 46px;
        }

        .juzhen {
            position: absolute;
            left: 50%;
            top: 24px;
            transform: translateX(-50%);
        }

        .recommend {
            position: absolute;
            right: 16px;
            top: 0;
            width: 37px;
            height: 37px;
            border-radius: 0 0 8px 8px;
            background: linear-gradient(to left, #FF8748, #FE5D46);

            &::before {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                border-radius: 8px;
                border-width: 13px 18.5px;
                border-style: solid;
                border-color: transparent transparent #F0C479 transparent;
            }

            &-text {
                position: relative;
                top: 10px;
                padding-top: 4px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 2px;
                    right: 2px;
                    top: 0;
                    height: 2px;
                    background-color: #fff;
                    border-radius: 2px;
                }
            }
        }

        .fit-to-text {
            opacity: .7;
        }

        .btn-wrapper {
            position: absolute;
            left: 50%;
            bottom: 12px;
            transform: translateX(-50%);

            .renew-btn {
                position: relative;
                width: 172px;
                height: 36px;
                line-height: 36px;
                border-radius: 26.5px;
                text-align: center;

                .dicount-bg {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: -6px;
                    right: -22px;
                    width: 46px;
                    height: 16px;
                    // background-color: red;
                    position: absolute;
                    color: #fff;
                    font-size: 14px;
                    font-weight: bold;
                    background: url('~@/assets/images/discountBg.svg') no-repeat;
                }
            }
        }
    }

    &__details {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        padding: 0 12px;

        li {
            img {
                width: 32px;
                height: 32px;
            }
        }
    }
}
</style>
